module.exports = __webpack_public_path__ + "static/media/erpweb.c26fa3fd.png";